import * as yup from 'yup'

const TribunalValidationSchema = yup.object().shape({
    greffe: yup
        .string()
        .required('Le greffe est requis'),
    numeroRole: yup
        .string()
        .required('Le numero de role est requis'),
    dateDépot: yup
        .string()
        .required('Le date est requis')
});

export default TribunalValidationSchema;